export const esTranslations = {
  errorBoundary: {
    title: 'Vaya, algo salió mal',
    message: 'Se produjo un problema inesperado. Puedes volver a intentarlo.',
  },
  api: {
    'ContactRequest.AlreadyExists': 'Ya has enviado una solicitud de contacto a este usuario',
    'Global.OperationNotAllowedError': 'No tienes permiso para realizar esta operación',
    'Global.ResourceDeletionNotAllowedError': 'No tienes permiso para eliminar este recurso',
    'Global.ResourceNotFoundError': 'El recurso no fue encontrado',
    'IdentityAndAccess.InvalidCredentialsError':
      'El correo electrónico o la contraseña es incorrecta',
    'IdentityAndAccess.EmailAlreadyTakenError': 'El correo electrónico ya está en uso',
    'Networking.CannotCancelNonPendingContactRequestError':
      'No puedes cancelar una solicitud de contacto que no está en estado PENDIENTE',
    'Networking.OnboardingAlreadyCompleteError': 'Ya has completado el proceso de incorporación',
    'Notifications.DeviceAlreadyRegisteredError': 'El dispositivo ya está registrado',
    'Networking.GhostProfileNoEmailError':
      'Este perfil no tiene dirección de correo. Añada un correo para enviar una invitación.',
    NetworkError: 'Error de red. Por favor, verifica tu conexión a internet.',
  },
  tabNavigation: {
    home: 'Inicio',
    contacts: 'Contactos',
    messages: 'Mensajes',
    notifications: 'Notificaciones',
    chatbot: 'Asistente IA',
    profile: 'Menú',
  },
  chatbot: {
    title: 'Asistente IA',
    placeholder: 'Pregúntame algo...',
    thinking: 'Pensando...',
    error: 'Ocurrió un error. Por favor, inténtalo de nuevo.',
    welcome:
      'Hola! Soy tu asistente IA. Puedo ayudarte a gestionar tus contactos, notas, categorías y hashtags. ¿Cómo puedo ayudarte?',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    actionConfirmed: 'Acción confirmada.',
    actionCancelled: 'Acción cancelada.',
    suggestionsTitle: 'Aquí tienes algunos ejemplos:',
    suggestions: {
      notes: 'Busca en todas mis notas',
      conversations: 'Resume mi última conversación de LinkedIn',
      sector: '¿Quién trabaja en ciberseguridad?',
      calendar: '¿Cuáles son mis próximas citas?',
      birthdays: '¿Qué cumpleaños se acercan?',
      findContact: 'Ayúdame a encontrar un contacto',
    },
  },
  welcome: {
    title: 'KEEPTOUCH',
    tagline: 'Un solo contacto puede cambiar toda una vida.',
    connection: 'Conexión',
    registration: 'Registro',
    slogan: 'Guarda, gestiona tus contactos del mañana \n Encuentra y realiza proyectos comunes',
  },
  login: {
    title: 'Iniciar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    button: 'Iniciar sesión',
    noAccount: 'No tengo cuenta',
    or: 'O',
    error: {
      noInfo: 'Ingresa tu información',
      wrongCredentials: 'El correo electrónico o la contraseña es incorrecta',
    },
  },
  register: {
    title: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    button: 'Registrarse',
    haveAccount: 'Ya tengo una cuenta',
    or: 'O',
    error: {
      noInfo: 'Ingresa tu información',
      notSamePassword: 'Las contraseñas no coinciden',
    },
  },
  registerSteps: {
    step2: '¿Qué prefieres? #',
    step3: '¿El mejor momento para contactarte?',
    skip: 'Saltar',
  },
  registerStep1: {
    title: {
      picture: 'Añade tu foto de perfil:',
      gender: 'Eres:',
      name: 'Tu nombre:',
      surname: 'Tu apellido:',
      birthday: 'Tu fecha de nacimiento:',
      athletic: '¿Eres deportista?:',
      info: 'Sobre ti:',
      languages: '¿Qué idiomas hablas?:',
      nationality: '¿Cuál es tu nacionalidad?:',
      origin: '¿Cuál es tu origen?:',
      personality: '¿Cuál es tu personalidad?:',
      residence: '¿Dónde vives?:',
      smoker: '¿Fumas?:',
      conditions: 'Acepto las condiciones',
    },
    value: {
      women: 'Mujer',
      man: 'Hombre',
      nonBinary: 'No binario',
      other: 'Otro',
      yes: 'Sí',
      no: 'No',
      calm: 'Tranquilo',
      active: 'Activo',
      talkative: 'Hablador',
    },
    next: 'Siguiente',
  },
  registerStepHastags: {
    mainTitle: 'Lo que te define #',
    title: 'Qué hashtags te corresponden',
    placeholder: '#deporte',
    next: 'Siguiente',
  },
  registerStep3: {
    mainTitle: '¿El mejor momento para contactarte?',
    title: 'Selecciona los momentos en los que estás más disponible',
    aperitif: 'Aperitivo',
    breakfast: 'Desayuno',
    coffee: 'Café',
    dinner: 'Cena',
    lunch: 'Almuerzo',
    walk: 'Paseo',
    video_call: 'Videollamada',
    phone_call: 'Llamada',
    weekend: 'Fin de semana',
    sport: 'Deporte',
    event: 'Evento',
    next: 'Siguiente',
  },
  registerStep4: {
    aperitif: 'Aperitivo',
    breakfast: 'Desayuno',
    coffee: 'Café',
    dinner: 'Cena',
    lunch: 'Almuerzo',
    walk: 'Paseo',
    videoCall: 'Videollamada',
    phoneCall: 'Llamada',
    weekend: 'Fin de semana',
    sport: 'Deporte',
    event: 'Evento',
    next: 'Siguiente',
  },
  registerFinalStep: {
    congrats: 'Felicidades,\n{name} {surname},\n tu cuenta ha sido creada',
    next: 'Siguiente',
    geolocationText: 'Activa la geolocalización para una mejor experiencia de usuario',
  },
  forgotPassword: {
    title: 'Restablecer contraseña',
    email: 'Correo electrónico',
    emailConfirm: 'Confirmar correo electrónico',
    button: 'Enviar enlace por correo',
    success:
      'Si existe una cuenta con este correo, recibirás un enlace de restablecimiento en breve.',
    error: {
      noEmail: 'Por favor, ingresa tu correo electrónico.',
      generic: 'Algo salió mal. Por favor, inténtalo de nuevo más tarde.',
    },
  },
  contact: {
    title: 'Contactos',
    searchPlaceholder: 'Buscar un contacto',
    commonContacts: '{nbr} contactos{newline} en común',
    commonProjects: '{nbr} proyectos{newline} en común',
    addButton: 'Añadir',
    addTitle: 'Añadir {name} a tu perfil',
    commonTitleModal: 'Amigos y proyectos en común',
    filter: {
      search: 'Buscar',
      category: {
        location: 'Lugares',
        origin: 'Origen',
        role: 'Función',
        degree: 'Grado',
        hashtag: '#',
      },
      location: {
        continent: 'Continente',
        country: 'Buscar un país',
        region: 'Estados / Región',
      },
      nonLocation: {
        origin: 'Buscar un origen',
        role: 'Buscar una función',
        hashtag: 'Buscar por #',
      },
    },
    emptyReceivedRequest: 'No hay solicitudes recibidas por el momento',
    emptySentRequest: 'No hay solicitudes enviadas por el momento',
    emptyContactPro: 'No hay contactos profesionales',
    emptyContactPrivate: 'No hay contactos privados',
  },
  addContact: {
    title: 'Buscar un contacto',
    commonContacts: '{nbr} contactos{newline} en común',
    commonProjects: '{nbr} proyectos{newline} en común',
    addButton: 'Añadir',
    addTitle: 'Añadir {name} a tu perfil',
    commonTitleModal: 'Amigos y proyectos en común',
    filter: {
      search: 'Buscar',
      category: {
        location: 'Lugares',
        origin: 'Origen',
        role: 'Función',
        degree: 'Grado',
        hashtag: '#',
      },
      location: {
        continent: 'Continente',
        country: 'Buscar un país',
        region: 'Estados / Región',
      },
      nonLocation: {
        origin: 'Buscar un origen',
        role: 'Buscar una función',
        hashtag: 'Buscar por #',
      },
    },
    emptyData: 'No hay contactos sugeridos',
    degree1: '1.º',
    degree2: '2.º',
    degree3: '3.º',
  },
  requestContact: {
    received: 'Recibidas',
    sended: 'Enviadas',
  },
  menu: {
    profileButton: 'Ver perfil',
    nonExistentProfile: 'Perfil no existente',
    share: 'Compartir',
    settings: 'Ajustes',
    signOut: 'Cerrar sesión',
    version: 'Versión {version}',
  },
  contactType: {
    PRIVATE: 'Privado',
    PROFESSIONAL: 'Pro',
    GROUP: 'Grupo',
    OTHERS: 'Otros',
    GHOST: 'Fantasma',
  },
  profile: {
    premiumTitle: 'Probar Premium',
    mainMenus: {
      updateProfile: 'Editar perfil',
      shareProfile: 'Compartir perfil',
      calendar: 'Calendario',
      memories: 'Recuerdos',
    },
    hashtags: {
      blocTitle: 'Competencias',
      learn: {
        title: 'Aprender',
        placeholder: 'Buscar tus objetivos...',
      },
      target: {
        title: 'Objetivos',
        placeholder: 'Construir una casa...',
      },
      hobby: {
        title: 'Pasatiempos',
        placeholder: '# hacer karate...',
      },
      skill: {
        title: 'Competencias',
        placeholder: 'Marketing...',
      },
      button: 'Guardar',
    },
    contact: {
      email: {
        title: 'Correo electrónico',
      },
      phoneNumber: {
        title: 'Número de teléfono',
      },
      website: {
        title: 'Sitio web',
      },
      fbProfile: {
        title: 'Perfil de Facebook',
      },
      instagramProfile: {
        title: 'Perfil de Instagram',
      },
      linkedinProfile: {
        title: 'Perfil de LinkedIn',
      },
      twitterProfile: {
        title: 'Perfil de Twitter',
      },
      availability: 'Disponibilidad',
      contact: 'Contacto',
    },
    presentation: {
      title: 'Presentación',
    },
    question: {
      title: 'Pregunta',
      button: 'Guardar',
      nationalities: {
        title: '¿Cuáles son tus nacionalidades?:',
        placeholder: 'Buscar una nacionalidad...',
      },
      origins: {
        title: '¿Cuáles son tus orígenes?:',
        placeholder: 'Buscar un origen...',
      },
      languages: {
        title: '¿Qué idiomas hablas?:',
        placeholder: 'Buscar un idioma...',
        modal: {
          title: 'Seleccionar un país',
          search: {
            placeholder: 'Buscar un país...',
          },
        },
      },
      countries: {
        title: '¿Qué países has visitado?:',
        placeholder: 'Buscar un país...',
      },
      addLanguage: {
        title: 'Añadir un idioma',
        button: 'Guardar',
        language: {
          title: 'Idioma',
          placeholder: 'Seleccionar un idioma',
        },
        level: {
          title: 'Nivel',
          placeholder: 'Seleccionar tu nivel',
          beginner: 'Principiante',
          intermediate: 'Intermedio',
          advanced: 'Avanzado',
          expert: 'Experto',
        },
      },
    },
    livingPlaces: {
      title: 'Lugares de residencia',
      addLivingPlace: {
        title: 'Añadir un lugar de residencia',
        button: 'Guardar',
        country: {
          title: 'País',
          placeholder: 'Seleccionar un país',
        },
        from: {
          title: 'Desde',
        },
        to: {
          title: 'Hasta',
        },
      },
    },
    about: {
      title: 'Saber más',
      save: 'Guardar',
      categories: {
        learn: {
          title: '¿Qué quieres aprender?',
          placeholder: 'Buscar tus objetivos...',
        },
        objective: {
          title: 'Objetivo',
          placeholder: '#construir una casa...',
        },
        hobby: {
          title: 'Pasatiempo',
          placeholder: '# hacer karate...',
        },
        skills: {
          title: 'Competencias',
          placeholder: '# Marketing...',
        },
      },
    },
    updateSuccess: 'Perfil actualizado',
  },
  search: {
    placeholder: 'Buscar',
  },
  imageUpload: {
    fromCamera: 'Tomar una foto',
    fromGallery: 'Importar desde el teléfono',
  },
  swipeable: {
    mute: 'Silenciar',
    pin: 'Fijar',
    unpin: 'Desfijar',
    delete: 'Eliminar',
  },
  errors: {
    title: 'Se ha producido un problema',
    logError: 'Por favor, inicia sesión de nuevo',
    generic: 'Algo salió mal. Inténtalo de nuevo.',
    'Global.ResourceNotFoundError': 'Recurso no encontrado.',
    'Global.OperationNotAllowed': 'Operación no permitida.',
    'Global.PermissionDenied': 'No tienes permiso para realizar esta acción.',
    'Global.ResourceDeletionNotAllowed': 'Este recurso no puede ser eliminado.',
    'Identity.Authentication.Unauthenticated': 'Por favor inicia sesión de nuevo.',
    'Identity.SignIn.InvalidCredentials': 'Email o contraseña incorrectos.',
    'Identity.SignUp.EmailAlreadyTaken': 'Este email ya está en uso.',
    'Identity.ResetPassword.InvalidOrExpiredToken':
      'El enlace de restablecimiento es inválido o ha expirado.',
    'Networking.ContactRequest.SelfContactRequest':
      'No puedes enviarte una solicitud de contacto a ti mismo.',
    'Networking.ContactRequest.AlreadyExists':
      'Ya existe una solicitud de contacto con esta persona.',
    'Networking.ContactRequest.NotFound': 'Solicitud de contacto no encontrada.',
    'Networking.Note.SharedNoteRequiresContact':
      'Una nota compartida debe estar vinculada a un contacto.',
    'Networking.Note.CannotShareWithSelf': 'No puedes compartirte una nota a ti mismo.',
    'Networking.Note.OnlyCreatorOrContactCanUpdate':
      'Solo el creador o el contacto vinculado pueden modificar esta nota.',
    'Networking.Note.SharedNoteContactMustDifferFromAuthor':
      'El contacto de una nota compartida debe ser distinto del autor.',
    'Networking.KeepContact.OnlyCreatorCanUpdate':
      'Solo el creador puede modificar este recordatorio.',
    'Networking.KeepContact.ContactNotFound': 'Contacto no encontrado.',
    'Networking.CalendarEvent.OnlyCreatorCanUpdate': 'Solo el creador puede modificar este evento.',
    'Networking.CalendarEvent.SomeParticipantsNotFound':
      'Algunos participantes no fueron encontrados.',
    'Networking.ScheduledMessage.RecipientOrGroupRequired':
      'Selecciona un destinatario o un grupo.',
    'Networking.ScheduledMessage.GroupNotFoundOrNotMember':
      'Grupo no encontrado o no eres miembro.',
    'Networking.ScheduledMessage.OnlyCreatorCanUpdate':
      'Solo el creador puede modificar este mensaje programado.',
    'Networking.ScheduledMessage.ContactNotFound': 'Contacto no encontrado.',
    'Networking.UpdateContactScope.GhostNotAllowed':
      'El alcance solo puede cambiarse para contactos reales.',
    'Networking.Profile.OnlyOwnerCanUpdate': 'Solo el propietario puede modificar este perfil.',
    'Networking.Hashtag.OnlyCreatorCanUpdate': 'Solo el creador puede modificar este hashtag.',
    'Networking.Contact.ProfileNotFound': 'Perfil de contacto no encontrado.',
    'Networking.Contact.RelationshipNotFound': 'Relación de contacto no encontrada.',
    'Networking.GhostProfile.NotFound': 'Perfil fantasma no encontrado.',
    'Networking.GhostProfile.NoEmail':
      'Este perfil fantasma no tiene correo electrónico registrado.',
    'Networking.MergeContacts.GhostNotFoundOrNotOwned':
      'Perfil fantasma no encontrado o no te pertenece.',
    'Networking.MergeContacts.RealContactNotFound': 'Contacto real no encontrado en tus contactos.',
    'Networking.Profile.NotFoundOrNoRelationship':
      'Perfil no encontrado o sin relación de contacto.',
    'Networking.Conversation.NotFound': 'Conversación no encontrada.',
    'Ft.Chatbot.ConfirmFailed': 'No se pudo confirmar la acción.',
    'Ft.Chatbot.ChatFailed': 'No se pudo procesar el mensaje del chatbot.',
    'Ft.VoiceNote.NoAudioFile': 'No se proporcionó archivo de audio.',
    'Ft.VoiceNote.ProcessingFailed': 'No se pudo procesar la nota de voz.',
    'Ft.ConversationAi.AnalyzeFailed': 'No se pudo analizar la conversación.',
    'Ft.ConversationAi.GenerateFailed': 'No se pudieron generar sugerencias.',
    'Ft.ConversationAi.SummarizeFailed': 'No se pudo resumir la conversación.',
    'Ft.BusinessCard.NoImageFile': 'No se proporcionó imagen.',
    'Ft.BusinessCard.ScanFailed': 'No se pudo escanear la tarjeta de visita.',
    'Ft.SocialImport.ImportNotFound': 'Importación no encontrada.',
    'Ft.SocialImport.ResultsNotReady': 'Los resultados de la importación aún no están disponibles.',
    'Ft.SocialImport.NetworkNotEnabled': 'La red "{network}" no está activada o configurada.',
    'Ft.SocialImport.UnsupportedNetwork': 'La red "{network}" no es compatible.',
    'Ft.SocialImport.NotInSucceededStatus': 'La importación no se completó con éxito.',
    'Ft.NearbyVisibility.UpdateFailed': 'No se pudo actualizar la visibilidad cercana.',
    'Ft.Translate.Failed': 'No se pudo traducir el texto.',
    'Notifications.DeviceAlreadyRegistered':
      'Este dispositivo ya está registrado para recibir notificaciones.',
    PLAN_LIMIT_CONTACTS_REACHED:
      'Has alcanzado el límite de {limit} contactos del plan gratuito. Hazte Keeptouch Infinity para tener contactos ilimitados.',
    PLAN_LIMIT_GHOST_PROFILES_REACHED:
      'Has alcanzado el límite de {limit} perfiles fantasma del plan gratuito. Hazte Keeptouch Infinity para tener perfiles fantasma ilimitados.',
    PLAN_LIMIT_NOTES_REACHED:
      'Has alcanzado el límite de {limit} notas del plan gratuito. Hazte Keeptouch Infinity para tener notas ilimitadas.',
    PLAN_LIMIT_REMINDERS_REACHED:
      'Has alcanzado el límite de {limit} recordatorios del plan gratuito. Hazte Keeptouch Infinity para tener recordatorios ilimitados.',
    PLAN_FEATURE_REMINDERS_DISABLED:
      'Los recordatorios son una función de Keeptouch Infinity. Hazte Keeptouch Infinity para no olvidar nunca mantener el contacto.',
  },
  common: {
    today: 'Hoy',
    tomorrow: 'Mañana',
    statusOverdue: 'Pasado',
    statusUpcoming: 'Próximo',
    statusDone: 'Hecho',
    all: 'Todos',
    cancel: 'Cancelar',
    add: 'Añadir',
    save: 'Guardar',
    back: 'Volver',
    edit: 'Editar',
    delete: 'Eliminar',
    confirmDelete: 'Confirmar eliminación',
    choose: 'Elegir',
    validate: 'Validar',
    private: 'Privado',
    pro: 'Pro',
    group: 'Grupo',
    personCount: '{count, plural, one {# persona} other {# personas}}',
    resultsCount: '{count, plural, one {# resultado} other {# resultados}}',
    contactCount: '{count, plural, one {# contacto} other {# contactos}}',
    memberCount: '{count, plural, one {# miembro} other {# miembros}}',
    parenCount: ' ({count})',
    selectedCount: '{count} seleccionado(s)',
    shared: 'Compartido',
    personal: 'Personal',
    filter: 'Filtro',
    momentFilterAll: 'Todo',
    momentFilterToday: 'Hoy',
    momentFilterWeek: 'Esta semana',
    momentFilterMonth: 'Este mes',
    momentFilterLater: 'Más tarde',
    scanBusinessCard: 'Escanear una tarjeta de visita',
    inCommon: 'En común',
    view: 'Ver',
    retry: 'Reintentar',
  },
  featureTooltip: {
    gotIt: 'Entendido',
    conversation_ai_panel: {
      description:
        'Sugerir: genera una respuesta. Resumir: vista general. Analizar: sentimiento y temas.',
    },
    scheduled_messages: {
      title: 'Mensajes programados',
      description:
        'Programa mensajes para enviar más tarde. La IA puede redactar el mensaje según el motivo (cumpleaños, saludo…). Desliza para editar o eliminar.',
    },
    scheduled_msg_reason: {
      title: 'Generación con IA',
      description:
        'Elige un motivo y añade detalles opcionales. La IA redactará un mensaje personalizado según el contexto y tu relación con el contacto.',
    },
    nearby_intro: {
      title: 'Contactos cercanos',
      description:
        'Descubre qué contactos están cerca de ti, en la misma ciudad o país. Tu ubicación se actualiza automáticamente en cada conexión.',
    },
    keep_contact: {
      title: 'Recordatorios de contacto',
      description:
        'Crea recordatorios para no olvidar volver a escribir. Define fecha, recurrencia y filtra por categoría o hashtag. Los atrasados aparecen en rojo.',
    },
    graph_intro: {
      title: 'Grafo de relaciones',
      description:
        'Explora visualmente tus contactos y sus vínculos. Haz zoom, arrastra y toca un contacto para ver su perfil. Activa el modo Completo para ver enlaces por categoría, hashtag, ciudad…',
    },
    listing_contacts: {
      title: 'Tus contactos',
      description:
        'Filtra por Privado o Pro con las pestañas. Usa + para añadir un contacto manualmente, escanear una tarjeta o importar desde una red social.',
    },
    card_scanner: {
      title: 'Escáner de tarjetas',
      description:
        'Haz una foto o importa una tarjeta de visita. La IA extraerá los datos y creará un contacto nuevo.',
    },
    social_import: {
      title: 'Importar contactos sociales',
      description:
        'Elige una red e introduce un nombre de usuario. La IA importará seguidores o contactos de ese perfil a tu agenda.',
    },
    merge_intro: {
      title: 'Fusionar duplicados',
      description:
        'La IA detecta contactos duplicados. Desliza a la derecha para fusionar, a la izquierda para ignorar. Toca un perfil para revisarlo antes de decidir.',
    },
    classify_swipe: {
      title: 'Clasifica tus contactos',
      description:
        'Desliza a la izquierda para Privado, a la derecha para Pro. También puedes usar los botones. Toca la tarjeta para abrir el perfil.',
    },
    chatbot_intro: {
      title: 'Asistente IA',
      description:
        'Pregunta por tus contactos, pide sugerencias o acciones como programar un mensaje. La IA puede buscar, analizar y actuar por ti.',
    },
  },
  graphScreen: {
    title: 'Grafo de relaciones',
    nativeWebOnlyBody: 'La visualización del grafo está disponible en la versión web.',
    nativeWebOnlySubtext:
      'Inicia sesión en keeptouch.co para explorar tus relaciones de forma interactiva.',
    loadingGraph: 'Cargando grafo…',
    mode: 'Modo',
    modeContacts: 'Contactos',
    modeFull: 'Completo',
    relations: 'Relaciones',
    statsLine: '{nodeCount} nodos · {edgeCount} enlaces',
    edgeContact: 'Contactos',
    edgeCategory: 'Categorías',
    edgeHashtag: 'Hashtags',
    edgeProfession: 'Profesiones',
    edgeNationality: 'Nacionalidades',
    edgeCity: 'Ciudades',
    legendMe: 'Yo',
    legendPrivate: 'Privado',
    legendPro: 'Pro',
    legendGhost: 'Fantasma',
    legendCategory: 'Categoría',
    legendHashtag: 'Hashtag',
    legendProfession: 'Profesión',
    legendNationality: 'Nacionalidad',
    legendCity: 'Ciudad',
    searchPlaceholder: 'Buscar en el grafo',
  },
  geolocation: {
    unavailable: {
      title: 'Geolocalización no disponible',
      message: 'La geolocalización no está disponible en este dispositivo.',
    },
    denied: {
      title: 'Permiso denegado',
      message:
        'Necesitamos acceso a tu ubicación para ofrecerte una mejor experiencia. ¿Deseas abrir los ajustes para activar la geolocalización?',
      cancel: 'Cancelar',
      settings: 'Ajustes',
    },
    blocked: {
      title: 'Permiso bloqueado',
      message:
        'El acceso a la geolocalización ha sido bloqueado. Por favor, ve a los ajustes de la aplicación para activarlo manualmente.',
      cancel: 'Cancelar',
      settings: 'Ajustes',
    },
  },
  contacts: {
    searchProfile: 'Buscar un perfil',
    addNonExistingProfile: 'Añadir un perfil no existente',
    importFromContacts: 'Importar desde mis contactos',
    uncontact: 'Eliminar de mis contactos',
    uncontactConfirmTitle: 'este contacto',
  },
  settings: {
    title: 'Ajustes',
    language: 'Idioma',
    languageDescription: 'Elige el idioma de la aplicación',
    auto: 'Automático (idioma del dispositivo)',
    french: 'Francés',
    english: 'Inglés',
    spanish: 'Español',
    location: 'Ubicación',
    locationDescription: 'Gestionar el acceso a tu ubicación',
    locationStatusUnknown: 'Estado: sin comprobar',
    locationStatusEnabled: 'Estado: activada',
    locationStatusDisabled: 'Estado: desactivada o no disponible',
    locationAction: 'Comprobar permiso de ubicación',
    locationToggle: 'Activar la ubicación',
    locationDenied: 'Ubicación bloqueada por el navegador. Permítela para este sitio.',
    subscription: 'Suscripción',
    subscriptionDescription: 'Tu plan actual de KeepTouch',
    subscriptionFree: 'Plan gratuito',
    subscriptionManage: 'Ver planes Premium',
    subscriptionPremium: 'Premium activo',
    calendarSync: 'Sincronización de calendario',
    calendarSyncDescription: 'Añade tus eventos de KeepTouch a tu calendario.',
    calendarSyncEnable: 'Sincronizar con mi calendario',
    calendarSyncPermissionDenied: 'Se necesita permiso de calendario para sincronizar.',
    deleteAccountTitle: 'Eliminar mi cuenta',
    deleteAccountDescription:
      'Elimina permanentemente tu cuenta y todos tus datos. Esta acción no se puede deshacer.',
    deleteAccountButton: 'Eliminar mi cuenta',
    deleteAccountConfirmTitle: '¿Eliminar tu cuenta?',
    deleteAccountConfirmMessage:
      'Esto es permanente: tu cuenta y todos tus datos (contactos, notas, mensajes…) se eliminarán. No podrás recuperarlos.',
    deleteAccountCancel: 'Cancelar',
    deleteAccountConfirm: 'Eliminar permanentemente',
    deleteAccountInProgress: 'Eliminando…',
    deleteAccountPasswordPlaceholder: 'Introduce tu contraseña',
    deleteAccountWrongPassword: 'Contraseña incorrecta.',
    deleteAccountError: 'No se pudo eliminar la cuenta. Inténtalo de nuevo.',
  },
  calendarModal: {
    month0: 'Enero',
    month1: 'Febrero',
    month2: 'Marzo',
    month3: 'Abril',
    month4: 'Mayo',
    month5: 'Junio',
    month6: 'Julio',
    month7: 'Agosto',
    month8: 'Septiembre',
    month9: 'Octubre',
    month10: 'Noviembre',
    month11: 'Diciembre',
    weekDay0: 'LUN',
    weekDay1: 'MAR',
    weekDay2: 'MIÉ',
    weekDay3: 'JUE',
    weekDay4: 'VIE',
    weekDay5: 'SÁB',
    weekDay6: 'DOM',
    time: 'Hora',
    schedule: 'Programar',
    subscriptionManage: 'Ver planes Premium',
    subscriptionPremium: 'Premium activo',
  },
  connectedServices: {
    sectionTitle: 'Servicios conectados',
    sectionDescription:
      'Conecta tus mensajerías para importar automáticamente tus contactos a KeepTouch.',
    connect: 'Conectar',
    connected: 'Conectado',
    reconnect: 'Reconectar',
    statusConnecting: 'Conectando…',
    wizardOpened: 'Termina la conexión en la pestaña que se acaba de abrir y vuelve aquí.',
    disconnect: 'Desconectar',
    disconnected: 'Servicio desconectado.',
    disconnectError: 'La desconexión falló, inténtalo de nuevo.',
    wizardError: 'No se pudo crear el enlace de conexión, inténtalo de nuevo.',
    refresh: 'Actualizar',
    filterPlaceholder: 'Filtro (opcional): p. ej. ciberseguridad, finanzas…',
    syncFilteredOut: '{filtered} contacto(s) fuera del filtro no importados',
    syncStarted: 'Importación iniciada — puede tardar unos minutos. ¡No hace falta desconectar el servicio! ⏳',
    syncInProgressHint: 'Importación en curso… Puede tardar unos minutos, puedes seguir usando la aplicación.',
    syncNow: 'Importar mis contactos',
    syncing: 'Importando…',
    syncResult: '{created} contacto(s) importado(s), {skipped} ya presentes',
    syncEmpty: 'No hay contactos nuevos para importar',
    syncError: 'La importación falló, inténtalo de nuevo.',
    planLimit: 'Límite del plan gratuito alcanzado — algunos contactos no se importaron.',
    noAccounts: 'Ningún servicio conectado por ahora.',
    serviceInstagram: 'Instagram',
    serviceWhatsapp: 'WhatsApp',
    serviceLinkedin: 'LinkedIn',
    serviceGmail: 'Gmail',
    calendarSync: 'Sincronizar Google Calendar',
    calendarSyncing: 'Sincronizando…',
    calendarConnect: 'Conectar Google Calendar',
    calendarSyncResult: '{created} evento(s) importado(s), {skipped} ya presentes',
    calendarSyncEmpty: 'Calendario ya al día',
    calendarSyncError: 'La sincronización falló, inténtalo de nuevo.',
  },
  subscription: {
    title: 'Suscripción',
    headline: 'Elige tu experiencia Keeptouch',
    intro: 'Dos planes para hacer crecer y cuidar tu red humana, a tu ritmo.',
    // Versión Gratuita
    freeTierTitle: 'Versión Gratuita',
    freeTierSubtitle: 'Para descubrir Keeptouch y organizar tus primeros contactos.',
    freePriceLabel: 'Gratis',
    freeFeatureContacts: 'Hasta 500 contactos sincronizables',
    freeFeatureGhosts: '30 perfiles fantasma',
    freeFeatureNotes: '10 notas personales como máximo',
    freeFeatureReminders: '3 recordatorios activos',
    freeFeatureMap: 'Mapa relacional en versión simplificada',
    freeFeatureNoStats: 'Sin estadísticas ni información inteligente',
    // Keeptouch Infinity
    infinityTierTitle: 'Keeptouch Infinity',
    infinityTierSubtitle: 'La experiencia completa para los constructores de red humana.',
    infinityBadge: 'Recomendado',
    infinityPriceFallback: '6,99 €/mes',
    infinityPricePerMonth: '{price}/mes',
    infinityFeatureUnlimited: 'Todo ilimitado',
    infinityFeatureGhosts: 'Perfiles fantasma ilimitados',
    infinityFeatureAI: 'IA relacional (análisis de vínculos, alertas, priorización inteligente)',
    infinityFeatureIntegrations: 'Integraciones avanzadas: WhatsApp, calendario, redes sociales',
    infinityFeatureMap: 'Mapa de red dinámico y evolutivo',
    infinityFeatureForecast: 'Previsiones de evolución de las relaciones',
    infinityCta: 'Iniciar Keeptouch Infinity',
    comingSoon: 'Muy pronto',
    comingSoonMessage: 'Keeptouch Infinity llega muy pronto. ¡Gracias por tu paciencia!',
    premiumTitle: 'Eres Infinity',
    premiumSubtitle: 'Gracias por formar parte de Keeptouch Infinity. Disfrutas de todas las funciones, sin límite.',
    premiumActive: 'Suscripción activa',
    expiresOn: 'Se renueva el {date}',
    processing: 'Procesando…',
    activating: 'Activando tu suscripción…',
    purchaseSuccessTitle: 'Bienvenido a Keeptouch Infinity',
    purchaseSuccessMessage: 'Tu suscripción está activa. ¡Disfruta de todas las funciones!',
    purchaseErrorTitle: 'No se pudo completar la compra',
    purchaseErrorMessage: 'La compra no se pudo completar. Inténtalo de nuevo.',
    restoreCta: 'Restaurar compras',
    restoring: 'Restaurando…',
    restoreSuccessTitle: 'Suscripción restaurada',
    restoreSuccessMessage: 'Tu suscripción Infinity se ha restaurado.',
    restoreNoneTitle: 'Nada que restaurar',
    restoreNoneMessage: 'No encontramos ninguna suscripción activa en esta cuenta.',
    restoreErrorTitle: 'No se pudo restaurar',
    restoreErrorMessage: 'La restauración no se pudo completar. Inténtalo de nuevo.',
    manageCta: 'Gestionar mi suscripción',
    manageErrorTitle: 'No se pudo abrir',
    manageErrorMessage: 'No se pudo abrir la página de gestión de la suscripción.',
    legalDisclosure:
      'Suscripción mensual de renovación automática de 6,99 €/mes. Se renueva automáticamente salvo cancelación al menos 24 h antes del fin del periodo. Puedes cancelar en cualquier momento en los ajustes de tu cuenta.',
    termsOfUse: 'Términos de uso',
    privacyPolicy: 'Política de privacidad',
  },
  planLimit: {
    title: 'Hazte Keeptouch Infinity',
    body: 'Has alcanzado un límite del plan gratuito. Hazte Keeptouch Infinity para desbloquear esta función.',
    upgrade: 'Hazte Keeptouch Infinity',
    later: 'Quizás más tarde',
  },
  export: {
    sectionTitle: 'Exportar mis contactos',
    sectionDescription:
      'Descarga todos tus contactos en formato vCard (.vcf), importable en cualquier agenda.',
    cta: 'Exportar mis contactos (.vcf)',
    exporting: 'Exportando…',
    successTitle: 'Exportación completada',
    successMessage: 'Tus contactos se exportaron en formato vCard.',
  },
  recurrence: {
    title: 'Recurrencia',
    custom: 'Personalizada',
    recurrence: 'Recurrencia',
    every: 'Cada',
    everyDay: 'Cada día',
    everyWeek: 'Cada semana',
    every2Weeks: 'Cada 2 semanas',
    every6Weeks: 'Cada 6 semanas',
    everyMonth: 'Cada mes',
    every3Months: 'Cada 3 meses',
    every6Months: 'Cada 6 meses',
    everyYear: 'Cada año',
    repeatOn: 'Repetir el',
    end: 'Fin',
    never: 'Nunca',
    on: 'El',
    after: 'Después de',
    lastDayOfMonth: 'Último día del mes',
    day: 'día',
    week: 'semana',
    month: 'mes',
    year: 'año',
    repetition: 'repetición',
  },
  calendarEvent: {
    createEvent: 'Crear una cita',
    editEvent: 'Modificar la cita',
    shared: 'Compartido',
    sharedCount: '{count, plural, one {Compartido} other {Compartidos}}',
    personal: 'Personal',
    eventName: 'Nombre de la cita',
    eventNamePlaceholder: 'Nombre de la cita...',
    addGuests: 'Añadir invitados',
    searchGuests: 'Buscar invitados...',
    eventDate: 'Fecha del evento',
    allDay: 'Todo el día',
    addLocation: 'Añadir un lugar',
    locationTitle: 'Lugar',
    description: 'Descripción',
    descriptionPlaceholder: 'Descripción...',
    alert: 'Alerta',
    alertEnabled: 'Alerta activada',
    noAlert: 'Sin alerta',
    inviteAndAdd: 'Invitar y añadir a KeepTouch',
    addToCalendar: 'Añadir solo a KeepTouch',
    addToGoogle: 'Añadir a Google Calendar',
    deleteConfirm: '¿Eliminar esta cita?',
    markAsDone: 'Marcar como hecho',
    markAsNotDone: 'Marcar como no hecho',
  },
  ghostProfile: {
    inviteToJoin: 'Invitar a unirse',
    inviteSent: 'Invitación enviada por correo electrónico.',
    inviteError: 'No se pudo enviar la invitación. Por favor, inténtelo de nuevo.',
    inviteErrorNoEmail:
      'Este perfil no tiene dirección de correo. Añada un correo para enviar una invitación.',
    editProfile: 'Editar perfil',
    about: 'Acerca de',
    presentation: 'Presentación',
    birthday: 'Cumpleaños',
    languages: 'Idiomas',
    nationalities: 'Nacionalidades',
    origins: 'Orígenes',
    contactInfo: 'Datos de contacto',
    email: 'Correo',
    phone: 'Teléfono',
    website: 'Sitio web',
    availabilities: 'Disponibilidad',
    livedPlaces: 'Lugares de residencia',
    categories: 'Categorías',
    searchCategories: 'Buscar categorías',
    keepContact: 'Mantener contacto',
    context: 'Contexto',
    hashtag: 'Hashtag',
    searchHashtags: 'Buscar hashtags',
    hashtags: 'Hashtags',
    objectives: 'Objetivos',
    hobby: 'Hobby',
    skills: 'Competencias',
    notes: 'Notas',
    appointments: 'Citas / Recordatorios',
    memories: 'Recuerdos',
    shareProfile: 'Compartir',
    message: 'Mensaje',
    requestSent: 'Solicitud enviada',
    openOnKeepTouch: 'Abrir en KeepTouch',
    edit: 'Editar',
    deleteProfile: 'Eliminar este perfil',
    deleteConfirmTitle: 'este perfil fantasma',
    deleteSuccess: 'Perfil fantasma eliminado',
    updateSuccess: 'Perfil fantasma actualizado',
    createSuccess: 'Perfil fantasma creado',
    noInteractionYet: 'No hay interacción todavía',
    lastInteraction: 'Última interacción {time}',
    viewMyProfile: 'Ver mi perfil',
    aboutProfile: 'Acerca del perfil',
    pins: 'Anclados',
  },
  contextes: {
    title: 'Contextos',
    meetingContext: 'Marco del encuentro',
    associatedEmotion: 'Emoción asociada',
    relationshipEvolution: 'Evolución de la relación',
    associatedColor: 'Color asociado',
    referencePlace: 'Lugar de referencia',
    enterPlace: 'Ingresa un lugar',
    chooseMeetingContext: 'Elegir el marco del encuentro',
    editMeetingContext: 'Modificar el marco del encuentro',
    chooseEmotion: 'Elegir la emoción asociada',
    editEmotion: 'Modificar la emoción asociada',
    chooseRelationship: 'Elegir la evolución de la relación',
    editRelationship: 'Modificar la evolución de la relación',
    chooseColor: 'Elegir el color asociado',
    editColor: 'Modificar el color asociado',
    searchMeetingContext: 'Buscar un marco de encuentro',
    searchEmotion: 'Buscar una emoción asociada',
    searchRelationship: 'Buscar una evolución de la relación',
    searchColor: 'Buscar un color asociado',
    save: 'Guardar',
    unsavedTitle: 'Cambios sin guardar',
    unsavedMessage: '¿Seguro que no quieres guardar?',
    leaveWithoutSaving: 'Salir sin guardar',
    keepEditing: 'Cancelar',
  },
  categories: {
    notFound: 'Categoría no encontrada',
    changePhoto: 'Cambiar la foto',
    chooseOption: 'Elige una opción',
    gallery: 'Galería',
    camera: 'Cámara',
    person: 'persona',
    persons: 'personas',
  },
  importContacts: {
    back: 'Volver',
    importCard: 'Importar una tarjeta de visita',
    businessCard: 'Tarjeta de visita',
    dragCard: 'Arrastra la tarjeta de visita aquí',
    or: 'O',
    selectFiles: 'Seleccionar de tus archivos',
    supportedFormats: 'Formatos admitidos: PDF, JPEG, PNG',
    startImport: 'Iniciar la importación',
    contactFound: 'Contacto encontrado en KeepTouch',
    profileFound: '¡Perfil encontrado!',
    addNewContact: 'Añadir un nuevo contacto:',
    validate: 'Validar y guardar la ficha',
    validating: 'Guardando…',
    checkInfo: 'Verificar la información importada',
    firstName: 'Nombre',
    enterFirstName: 'Ingresa el nombre',
    lastName: 'Apellido',
    enterLastName: 'Ingresa el apellido',
    profession: 'Profesión',
    enterProfession: 'Ingresa la profesión',
    company: 'Empresa',
    enterCompany: 'Ingresa la empresa',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    website: 'Sitio web',
    hashtag: 'Hashtag',
    hashtagPlaceholder: 'Nombre del #...',
    categoriesLabel: 'Categorías',
    addNewContactButton: 'Añadir un nuevo contacto',
    searchProfession: 'Buscar una profesión',
    file: {
      title: 'Importar desde un archivo CSV',
      subtitle:
        'Suelta una exportación CSV de tu CRM: se creará automáticamente un perfil fantasma para cada contacto.',
      drag: 'Arrastra tu archivo aquí',
      formats: 'Formato admitido: CSV (.csv)',
      fullName: 'Nombre completo',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'Twitter / X',
      notes: 'Notas',
      unsupportedFormat: 'Formato no admitido. Elige un archivo CSV (.csv). Exporta primero los archivos Excel a CSV.',
      empty: 'El archivo no contiene ninguna fila de contacto.',
      parseError: 'No se pudo leer el archivo. Comprueba que sea un CSV válido.',
      detected: '{count} contacto(s) detectado(s) en el archivo',
      columnsDetected: 'Columnas reconocidas automáticamente:',
      noUsableRows: 'No hay filas utilizables: se necesita al menos un nombre, email o teléfono.',
      importButton: 'Importar {count} contacto(s)',
      importing: 'Creando perfiles… {done} / {total}',
      doneTitle: '{count} contacto(s) importado(s) con éxito',
      doneDetails: '{skipped} fila(s) omitida(s), {failed} con error',
      importAnother: 'Importar otro archivo',
      importedToast: '{count} perfil(es) fantasma creado(s)',
    },
  },
  contactsList: {
    noContactFound: 'Ningún contacto encontrado',
    contactViaSocial: 'Contactar por redes sociales',
  },
  socialNetwork: {
    contactViaLinkedin: 'Contactar por LinkedIn',
    contactViaFacebook: 'Contactar por Facebook',
    contactViaInstagram: 'Contactar por Instagram',
    contactViaTwitter: 'Contactar por Twitter',
  },
  keepContact: {
    editReminder: 'Editar seguimiento',
    createReminder: 'Crear un seguimiento',
    reminderTitle: 'Título del seguimiento',
    reminderTitlePlaceholder: 'Nombre del seguimiento...',
    description: 'Descripción',
    descriptionPlaceholder: 'Descripción...',
    addContact: 'Añadir un contacto',
    searchContact: 'Buscar un contacto...',
    contactLabel: 'Contacto',
    eventDate: 'Fecha del evento',
    addLocation: 'Añadir un lugar',
    location: 'Lugar',
    alert: 'Alerta',
    alertEnabled: 'Alerta activada',
    noAlert: 'Sin alerta',
    alertActive: 'Activa',
    alertInactive: 'Inactiva',
    backToProfile: 'Volver al perfil',
    pageTitle: 'Mantener contacto',
    reminder: 'seguimiento',
    reminders: 'seguimientos',
    deleteConfirm: 'este seguimiento',
    filter: 'Filtro',
    none: 'Ninguna',
    keepContactWith: 'Mantener contacto con {contactName}',
    listView: 'Lista',
    boardView: 'Tablero',
  },
  resetPassword: {
    title: 'Definir nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    button: 'Restablecer contraseña',
    success: 'Tu contraseña ha sido restablecida. Ya puedes iniciar sesión.',
    error: {
      noToken: 'Enlace de restablecimiento inválido o faltante. Por favor, solicita uno nuevo.',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      generic: 'El enlace puede haber expirado. Por favor, solicita uno nuevo.',
    },
  },
  photoAlert: {
    title: 'Elegir una foto',
    message: 'Selecciona una opción',
  },
  qrCode: {
    shareMessage: 'Descubre mi perfil KeepTouch: {url}',
    shareTitle: 'Mi perfil KeepTouch',
    error: 'Error',
    shareError: 'No se pudo compartir el perfil',
    success: 'Éxito',
    linkCopied: 'Enlace copiado al portapapeles',
    copyError: 'No se pudo copiar el enlace',
    info: 'Información',
    downloadTodo: 'Función de descarga por implementar',
    notKeepTouchUrl: 'Este código QR no contiene un enlace a un perfil KeepTouch.',
    scanTitle: 'Escanear código QR',
    scanInstruction: 'Apunta tu cámara hacia un código QR de KeepTouch para escanearlo.',
    scanWebFallbackActive: 'Usando escáner alternativo para tu navegador.',
    cameraPermissionTitle: 'Acceso a la cámara requerido',
    cameraPermissionMessage:
      'Por favor, permite el acceso a la cámara en la configuración de tu navegador para escanear códigos QR.',
  },
  webNav: {
    search: 'Buscar',
    allContacts: 'Todos mis contactos',
    messaging: 'Mensajería',
    notifications: 'Notificaciones',
    myProfile: 'Mi perfil',
    signOut: 'Cerrar sesión',
    settings: 'Ajustes',
  },
  menuItems: {
    importContacts: 'Importar contactos',
    classifyProfiles: 'Clasificar perfiles',
    mergeProfiles: 'Fusionar perfiles',
    maps: 'Mapas',
    notes: 'Notas',
    categories: 'Categorías',
    hashtags: 'Hashtags',
    relationalColors: 'Colores relacionales',
    appointments: 'Citas / Recordatorios',
    birthdays: 'Cumpleaños',
    keepContact: 'Mantener contacto',
    scheduledMessages: 'Mensajes programados',
    qrCode: 'Código QR',
    settings: 'Ajustes',
    graph: 'Gráfico relacional',
    nearby: 'Contactos cercanos',
  },
  form: {
    contactInfo: 'Info de contacto',
    about: 'Acerca de',
    woman: 'Mujer',
    man: 'Hombre',
    mainInfo: 'Información principal',
    firstName: 'Nombre',
    enterFirstName: 'Ingresa el nombre',
    lastName: 'Apellido',
    enterLastName: 'Ingresa el apellido',
    professions: 'Profesión(es)',
    enterProfession: 'Ingresa la profesión',
    company: 'Empresa',
    enterCompany: 'Nombre de la empresa (opcional)',
    email: 'Correo electrónico',
    phoneNumber: 'Número de teléfono',
    socialNetworks: 'Redes sociales',
    website: 'Sitio web',
    descriptionPlaceholder: 'Descripción...',
    presentation: 'Presentación',
    birthDate: 'Fecha de nacimiento',
    livingPlace: 'Lugar de residencia',
    origins: 'Orígenes',
    nationalities: 'Nacionalidades',
    nationalityPlaceholder: 'Nacionalidad',
    spokenLanguages: 'Idiomas hablados',
    enterLanguages: 'Ingresa los idiomas',
    livedPlaces: 'Lugares vividos',
    hashtags: 'Hashtags',
    availabilityAndMeetings: 'Disponibilidad y tipos de encuentros',
    availability: 'Disponibilidad',
    bestMoment: 'Mejor momento',
    bestMoments: 'Mejores momentos',
    chooseDay: 'Elegir un día',
    chooseTime: 'Elegir una hora',
    days: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
    },
    searchLanguage: 'Buscar un idioma',
    searchPlace: 'Buscar un lugar',
    searchNationality: 'Buscar una nacionalidad',
    searchHashtags: 'Buscar hashtags',
    searchCategories: 'Buscar categorías',
    searchProfession: 'Buscar una profesión',
    backToProfile: 'Volver al perfil',
    backToContacts: 'Volver a la lista de contactos',
    editGhostProfile: 'Editar perfil fantasma',
    createGhostProfile: 'Crear perfil fantasma',
    addMeetingContext: 'Añadir marco de encuentro',
    addNewContact: 'Añadir un nuevo contacto',
    addNewProfile: 'Añadir un nuevo perfil',
    addContact: 'Añadir un contacto',
    searchContact: 'Buscar un contacto...',
    addNonExistingProfile: 'Añadir un perfil no existente',
  },
  messaging: {
    searchPlaceholder: 'Buscar un mensaje o contacto',
    groupNamePlaceholder: 'Nombre del grupo (opcional)',
    recipientPlaceholder: 'Ingresa tu destinatario...',
    messagePlaceholder: 'Escribe tu mensaje...',
    aboutGroup: 'Acerca del grupo',
    seen: 'Visto',
    createNewMessage: 'Crear un nuevo mensaje',
  },
  profileEdit: {
    editMyProfile: 'Editar mi perfil',
    backToMyProfile: 'Volver a mi perfil',
    about: 'Acerca de:',
    categories: 'Categorías',
    searchCategories: 'Buscar categorías',
  },
  livingPlaceForm: {
    editTitle: 'Editar lugar de residencia',
    addTitle: 'Añadir lugar de residencia',
    place: 'Lugar',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    currently: 'Actualmente',
  },
  notesForm: {
    addNote: 'Añadir una nota',
    editNote: 'Editar la nota',
    titlePlaceholder: 'Título',
    notePlaceholder: 'Nota',
    sharedWith: 'Compartida con ',
    addContact: 'Añadir un contacto',
    selectContactTitle: 'Elegir un contacto',
    personalNote: 'Nota personal',
    personalNoteSubtitle: 'Para ti mismo',
  },
  recurrenceComponent: {
    everyDay: 'Todos los días',
    everyWeek: 'Todas las semanas',
    everyMonth: 'Todos los meses',
    everyYear: 'Todos los años',
    recurrence: 'Recurrencia',
    every: 'Cada',
    repeatOn: 'Repetir el',
    monthDetail: 'Detalle por mes',
    lastDayOfMonth: 'Último día del mes',
    end: 'Fin',
    never: 'Nunca',
    on: 'El',
    after: 'Después de',
    day: 'día',
    days: 'días',
    week: 'semana',
    weeks: 'semanas',
    month: 'mes',
    year: 'año',
    years: 'años',
    repetition: 'repetición',
    repetitions: 'repeticiones',
  },
  filters: {
    title: 'Filtros',
    gender: 'Sexo',
    age: 'Edad',
    min: 'Mín',
    max: 'Máx',
    genderFemale: 'F',
    genderMale: 'M',
    genderNonBinary: 'NB',
    genderFemaleLong: 'Femenino',
    genderMaleLong: 'Masculino',
    genderNonBinaryLong: 'No binario',
    residence: 'Lugar de residencia',
    residenceContinent: 'Continente',
    residenceCountry: 'País',
    residenceRegion: 'Región',
    residenceCity: 'Ciudad',
    livedPlaces: 'Lugares vividos',
    origin: 'Origen',
    nationality: 'Nacionalidad',
    profession: 'Profesión',
    meetingContext: 'Marco del encuentro',
    associatedEmotion: 'Emoción asociada',
    relationshipEvolution: 'Evolución de la relación',
    associatedColor: 'Color asociado',
    language: 'Idioma',
    category: 'Categoría',
    hashtag: 'Hashtag',
    searchPlace: 'Buscar un lugar',
    activitySector: 'Sector de actividad',
    searchSector: 'Buscar un sector',
    searchHashtags: 'Buscar hashtags',
    searchHashtag: 'Buscar un hashtag',
    searchCategories: 'Buscar categorías',
    searchCategory: 'Buscar una categoría',
    searchMeetingContext: 'Buscar un marco de encuentro',
    searchEmotion: 'Buscar una emoción asociada',
    searchRelationship: 'Buscar una evolución de la relación',
    searchColor: 'Buscar un color asociado',
    searchLanguage: 'Buscar un idioma',
    contact: 'Contacto',
    eventDate: 'Fecha del evento',
    addPlace: 'Añadir un lugar',
    place: 'Lugar',
  },
  hashtagForm: {
    addTitle: 'Añadir un hashtag',
    editTitle: 'Editar el hashtag',
    backToList: 'Volver a la lista de hashtags',
    namePlaceholder: 'Nombre...',
  },
  deleteModal: {
    confirmMessage: '¿Estás seguro de que quieres eliminar {title}?',
    delete: 'Eliminar',
    cancel: 'Cancelar',
  },
  relationalColorForm: {
    editTitle: 'Editar color relacional',
    namePlaceholder: 'Nombre...',
  },
  addContactModal: {
    addPerson: 'Añadir {name}',
    addDefaultPerson: 'Añadir nombre de la persona',
    addPrivate: 'Añadir como Privado',
    addProfessional: 'Añadir como Profesional',
    requestSent: 'Solicitud enviada',
  },
  addHashtagModal: {
    title: 'Añadir un hashtag',
    save: 'Guardar',
  },
  addCategoryModal: {
    title: 'Añadir una categoría',
    save: 'Guardar',
  },
  menuContactsList: {
    addContacts: 'Añadir contactos',
    linkedContacts: 'Contactos vinculados',
  },
  memoriesForm: {
    addPhoto: 'Añadir una foto',
    editMemory: 'Editar recuerdo',
    addMemory: 'Añadir un recuerdo',
    memory: 'Recuerdo',
    selectMemory: 'Selecciona un recuerdo',
    description: 'Descripción:',
    identifyContacts: 'Identificar contactos:',
    identifiedContacts: 'Contactos identificados',
    publish: 'Publicar',
    sharedMemories: 'Recuerdos compartidos',
    sharedAlbums: 'Álbumes compartidos',
    deleteMemoryDescription: '¿Deseas eliminar solo esta foto o el álbum completo?',
    deletePhoto: 'Eliminar esta foto',
    deleteAlbum: 'Eliminar el álbum',
    deleteAlbumDescription: '¿Estás seguro de que deseas eliminar este álbum completo?',
  },
  albums: {
    title: 'Álbumes',
    createAlbum: 'Crear álbum',
    albumName: 'Nombre del álbum',
    albumTitle: 'Título del álbum',
    defaultTitle: 'Mi álbum',
    description: 'Descripción',
    empty: 'Sin álbumes por el momento',
    deleteConfirm: '¿Estás seguro de que quieres eliminar este álbum?',
  },
  creationStack: {
    addNote: 'Añadir una nota',
    conversation: 'Conversación',
    createEvent: 'Crear un evento',
    addReminder: 'Añadir un recordatorio',
    scheduleMessage: 'Programar mensaje',
    composeMessage: 'Redactar mensaje',
  },
  calendarAddEvent: {
    notActive: 'No activa',
    active: 'Activa',
  },
  toast: {
    success: 'Éxito',
    error: 'Error',
    info: 'Info',
    scheduledMessageDeleted: 'Mensaje programado eliminado',
    scheduledMessageCreated: 'Mensaje programado creado',
    scheduledMessageUpdated: 'Mensaje programado actualizado',
    reminderUpdated: 'Cita / Recordatorio actualizado',
    reminderDeleted: 'Cita / Recordatorio eliminado',
    reminderCreated: 'Cita / Recordatorio creado',
    eventDeleted: 'Evento eliminado',
    eventCreated: 'Evento creado',
    eventUpdated: 'Evento actualizado',
    colorUpdated: 'Color actualizado',
    contactRequestSent: 'Solicitud enviada',
    contactRequestSentMessage: 'Tu solicitud de amistad ha sido enviada.',
    scopeChanged: 'Ámbito modificado',
    categoryUpdated: 'Categoría actualizada',
    categoryCreated: 'Categoría creada',
    categoryDeleted: 'Categoría eliminada',
    noteCreated: 'Nota creada',
    noteUpdated: 'Nota actualizada',
    noteDeleted: 'Nota eliminada',
    hashtagUpdated: 'Hashtag actualizado',
    hashtagDeleted: 'Hashtag eliminado',
    hashtagCreated: 'Hashtag creado',
    memoryCreated: 'Recuerdo añadido',
    memoryUpdated: 'Recuerdo actualizado',
    memoryDeleted: 'Recuerdo eliminado',
    albumCreated: 'Álbum creado',
    albumDeleted: 'Álbum eliminado',
  },
  voiceNote: {
    error: 'Error al procesar la nota vocal',
    vocal: 'Vocal',
    successProfileUpdated: 'Perfil actualizado',
    successNoteCreated: 'Nota creada',
    successProcessed: 'Nota de voz procesada',
  },
  messagesScreen: {
    private: 'Privado',
    pro: 'Pro',
    groups: 'Grupos',
    other: 'Otro',
    pinnedMessages: 'Ver mensajes fijados',
    viewNotes: 'Ver notas',
    viewMedia: 'Ver medios',
    viewMembers: 'Ver miembros',
    customizeGroup: 'Personalizar grupo',
    share: 'Compartir',
    block: 'Bloquear',
    report: 'Reportar',
    group: 'Grupo',
    members: 'Miembros',
    persons: '{count} personas',
  },
  contactsScreen: {
    personFound: 'persona encontrada',
    personsFound: 'personas encontradas',
    noContactFound: 'Ningún contacto encontrado',
    professionNotSpecified: 'Profesión no especificada',
    profilesRemainingToMerge: 'perfiles restantes por fusionar',
    profileRemainingToMerge: 'perfil restante por fusionar',
    noProfileToMerge: 'Ningún perfil por fusionar',
    mergeProfiles: 'Fusionar perfiles',
    merge: 'Fusionar',
    swipeToMerge: 'Desliza a la derecha para fusionar, a la izquierda para ignorar.',
    swipeMergeInstruction: 'Desliza a la derecha para fusionar, a la izquierda para ignorar.',
    profilesRemainingToClassify: 'perfiles restantes por clasificar',
    profileRemainingToClassify: 'perfil restante por clasificar',
    noProfileToClassify: 'Ningún perfil por clasificar',
    classifyProfiles: 'Clasificar perfiles',
    swipeToClassify:
      'Desliza a la derecha o izquierda para definir el contacto como pro o privado.',
    swipeClassifyInstruction:
      'Desliza a la derecha o izquierda para definir el contacto como pro o privado.',
    coordinates: 'Datos de contacto',
    import: 'Importar',
    importContacts: 'Importar contactos',
    importAll: 'Importar todo',
    allContactsImported: 'Todos los contactos han sido importados',
    pleaseSyncContacts: 'Por favor sincroniza tus contactos',
    allImported: 'Todos los contactos han sido importados',
    syncContacts: 'Sincronizar mis contactos',
    selected: 'seleccionado',
    contactFound: '¡Contacto encontrado!',
    profileFound: '¡Perfil encontrado!',
    contactFoundScan: '¡Contacto encontrado!',
    profileFoundScan: '¡Perfil encontrado!',
  },
  profileScreen: {
    noLivingPlaceAdded: 'Ningún lugar de residencia añadido',
    pressToAddFirstPlace: 'Toca + para añadir tu primer lugar',
    tapToAddFirstPlace: 'Toca + para añadir tu primer lugar',
    noDataAdded: 'No hay datos añadidos',
    noAvailabilityAdded: 'No hay disponibilidad añadida',
    noContactInfoAdded: 'No hay datos de contacto añadidos',
    noHashtagAdded: 'Ningún hashtag añadido',
    backToMyProfile: 'Volver a mi perfil',
    aboutSection: 'Acerca de:',
    uploadMemory: 'Sube tu recuerdo:',
    selectMemory: 'Selecciona un recuerdo',
    taggedContacts: 'Contactos etiquetados',
    contactTagged: 'Contacto etiquetado:',
    contactsTagged: 'Contactos etiquetados:',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    currently: 'Actualmente',
    cityOrCountryName: 'Nombre de la ciudad o país',
    duration: 'Duración',
    currentlyLivingHere: 'Actualmente vivo en este lugar',
  },
  notesScreen: {
    title: 'Notas',
    sharedNote: 'Nota compartida',
    personalNote: 'Nota personal',
    shared: 'compartida',
    personal: 'personal',
  },
  scheduledMessagesScreen: {
    private: 'Privado',
    pro: 'Pro',
    groups: 'Grupos',
    categoriesTab: 'Categorías',
    title: 'Mensajes programados',
    results: '{count} resultados',
    scheduledFor: 'Programado para {time}',
    editing: 'Edita el mensaje abajo',
    deleteConfirm: 'este mensaje programado',
    createMessage: 'Crear un mensaje',
    chooseRecipient: 'Elegir un destinatario',
    typeMessage: 'Escribir un mensaje',
    deleteScheduledMessage: 'Eliminar el mensaje programado',
  },
  hashtagsScreen: {
    notFound: 'Hashtag no encontrado',
    newHashtag: 'Nuevo hashtag',
    person: '{count} persona',
    persons: '{count} personas',
    results: '{count} resultado',
    resultsPlural: '{count} resultados',
  },
  relationalColorsScreen: {
    title: 'Colores relacionales',
    notFound: 'Color asociado no encontrado',
    person: '{count} persona',
    persons: '{count} personas',
    results: '{count} resultado',
    resultsPlural: '{count} resultados',
  },
  categoriesScreen: {
    title: 'Categorías',
    addSubcategory: 'Añadir una subcategoría',
    subcategoryPhoto: 'Foto de la subcategoría',
    subcategoryPlaceholder: 'Título de la subcategoría...',
    categoryPhoto: 'Foto de la categoría',
    newCategory: 'Nueva categoría',
    categoryTitlePlaceholder: 'Título de la categoría...',
    addCategory: 'Añadir una categoría',
    addSubcategoryWithPhoto: 'Añadir una subcategoría',
    person: '{count} persona',
    persons: '{count} personas',
    backToList: 'Volver a la lista de categorías',
  },
  notificationsScreen: {
    toAddPeople: 'para añadir personas',
    acceptAsPro: 'Aceptar como profesional',
    acceptAsPrivate: 'Aceptar como privado',
    accept: 'Aceptar',
  },
  notifications: {
    friendRequest: 'Solicitud de contacto',
    acceptedRequest: 'Solicitud aceptada',
    rejectedRequest: 'Solicitud rechazada',
    upcomingEvent: 'Evento próximo',
    contactReminder: 'Recordatorio Keep in touch',
    scheduledMessage: 'Mensaje programado',
    birthday: 'Cumpleaños',
    syncContacts: 'Sincronizar mis contactos',
    toAddPeople: 'Para añadir personas',
    all: 'Todo',
    requests: 'Solicitudes',
    agenda: 'Agenda',
    accept: 'Aceptar',
    reject: 'Rechazar',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
    acceptAsPro: 'Aceptar como profesional',
    acceptAsPrivate: 'Aceptar como privado',
    orRejectRequest: 'O rechazar la solicitud',
    sections: {
      today: 'Hoy',
      thisWeek: 'Esta semana',
      earlier: 'Antes',
    },
    empty: {
      title: 'Estás al día',
      subtitle: 'No tienes ninguna notificación por ahora.',
    },
  },
  mapScreen: {
    title: 'Mapa',
    contactFound: '{count} contacto encontrado en esta zona',
    contactsFound: '{count} contactos encontrados en esta zona',
    contactsFoundInZone:
      '{count, plural, =0 {Sin contactos en esta zona} one {{count} contacto encontrado en esta zona} other {{count} contactos encontrados en esta zona}}',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    zoomLevel: 'Nivel de zoom',
  },
  birthdaysScreen: {
    title: 'Cumpleaños',
    upcoming: 'Próximos cumpleaños',
    private: 'Privado',
    pro: 'Pro',
    noBirthday: 'Ningún cumpleaños',
  },
  keepContactScreen: {
    private: 'Privado',
    pro: 'Pro',
  },
  qrCodeScreen: {
    shareProfile: 'Compartir perfil',
    copyLink: 'Copiar enlace',
    download: 'Descargar',
  },
  webFooter: {
    legalNotice: 'Aviso legal',
    contactUs: 'Contáctanos',
    privacyPolicy: 'Política de privacidad',
    joinUs: 'Únete a nosotros',
  },
  legalNotice: {
    editor: 'Editor',
    editorContent:
      'KeepTouch SAS\nCapital social: 10.000 €\nSede social: París, Francia\nNúmero de registro: RCS París\nDirector de publicación: Equipo KeepTouch',
    hosting: 'Alojamiento',
    hostingContent:
      'La aplicación está alojada por Amazon Web Services (AWS)\nDirección: 38 Avenue John F. Kennedy, L-1855 Luxemburgo',
    intellectualProperty: 'Propiedad intelectual',
    intellectualPropertyContent:
      'Todo el contenido de la aplicación KeepTouch (textos, imágenes, logotipos, iconos, software) es propiedad exclusiva de KeepTouch SAS y está protegido por las leyes francesas e internacionales de propiedad intelectual. Queda prohibida cualquier reproducción, representación o distribución sin autorización previa por escrito.',
    liability: 'Responsabilidad',
    liabilityContent:
      'KeepTouch SAS se esfuerza por proporcionar información precisa y actualizada. Sin embargo, no puede garantizar la exactitud, exhaustividad o actualidad de la información disponible en la aplicación. KeepTouch SAS no será responsable de ningún daño directo o indirecto resultante del uso de la aplicación.',
  },
  contactUs: {
    description:
      '¿Tienes una pregunta, una sugerencia o necesitas ayuda? No dudes en contactarnos. Nuestro equipo te responderá lo antes posible.',
    emailLabel: 'Correo electrónico',
    email: 'contact@keeptouch.app',
    addressLabel: 'Dirección',
    address: 'KeepTouch SAS\nParís, Francia',
  },
  privacyPolicy: {
    introduction:
      'KeepTouch se compromete a proteger la privacidad y los datos personales de sus usuarios. Esta política de privacidad describe cómo recopilamos, utilizamos y protegemos su información.',
    dataCollection: 'Recopilación de datos',
    dataCollectionContent:
      'Recopilamos los datos que usted proporciona voluntariamente al crear su cuenta y al utilizar la aplicación: nombre, dirección de correo electrónico, contactos, notas, recordatorios y cualquier otra información que decida compartir.',
    dataUsage: 'Uso de datos',
    dataUsageContent:
      'Sus datos se utilizan exclusivamente para proporcionar y mejorar el servicio KeepTouch. No vendemos ni compartimos sus datos personales con terceros con fines de marketing.',
    dataProtection: 'Protección de datos',
    dataProtectionContent:
      'Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger sus datos personales contra el acceso, modificación, divulgación o destrucción no autorizados.',
    cookies: 'Cookies',
    cookiesContent:
      'La aplicación puede utilizar cookies y tecnologías similares para mejorar la experiencia del usuario y analizar el uso. Puede gestionar sus preferencias de cookies en cualquier momento desde su configuración.',
    rights: 'Sus derechos',
    rightsContent:
      'De acuerdo con el RGPD, usted tiene derecho a acceder, rectificar, eliminar y portar sus datos personales. También tiene derecho a limitar y oponerse al tratamiento de sus datos. Para ejercer estos derechos, contáctenos en: contact@keeptouch.app',
  },
  joinUs: {
    description:
      'KeepTouch es una aplicación innovadora dedicada a ayudar a las personas a mantener y fortalecer sus relaciones. ¡Únete a nuestro equipo y contribuye a un proyecto que marca la diferencia!',
    whyJoin: '¿Por qué unirse a KeepTouch?',
    whyJoinContent:
      '• Trabajar en un proyecto innovador con impacto social\n• Unirse a un equipo apasionado y dinámico\n• Entorno de trabajo flexible y compatible con el teletrabajo\n• Oportunidades de crecimiento y desarrollo',
    positions: 'Puestos abiertos',
    positionsContent:
      'Siempre estamos buscando personas talentosas para unirse a nuestro equipo. Las ofertas actuales incluyen:\n\n• Desarrollador Full-Stack (React Native / NestJS)\n• Diseñador UX/UI\n• Responsable de Marketing y Growth\n• Community Manager',
    apply: 'Cómo postularse',
    applyEmail: 'jobs@keeptouch.app',
  },
  emotionalContexts: {
    'affection-intimite': {
      name: 'Afecto e Intimidad',
      description: 'Estos contactos nutren tu corazón.',
    },
    'aspiration-inspiration': {
      name: 'Aspiración e Inspiración',
      description: 'Estos contactos te impulsan hacia arriba.',
    },
    'stimulation-aventure': {
      name: 'Estimulación y Aventura',
      description: 'Estos contactos traen movimiento y emoción a tu vida.',
    },
    'soutien-stabilite': {
      name: 'Apoyo y Estabilidad',
      description: 'Estos contactos te apoyan emocionalmente y te dan estructura.',
    },
    'reflexion-profondeur': {
      name: 'Reflexión y Profundidad',
      description: 'Estos contactos te ayudan a pensar, comprenderte y evolucionar.',
    },
    'lacher-prise-detente': {
      name: 'Soltar y Relajación',
      description: 'Estos contactos te ayudan a respirar, desconectar y existir sin presión.',
    },
    affection: 'Afecto',
    'joie-chaleureuse': 'Alegría cálida',
    'tendre-complicite': 'Tierna complicidad',
    'presence-reconfortante': 'Presencia reconfortante',
    'partage-authentique': 'Compartir auténtico',
    aspiration: 'Aspiración',
    motivation: 'Motivación',
    source: 'Fuente',
    'elan-creatif': 'Impulso creativo',
    'grandeur-ame': 'Grandeza de alma',
    stimulation: 'Estimulación',
    aventure: 'Aventura',
    exploration: 'Exploración',
    'adrenaline-partagee': 'Adrenalina compartida',
    fun: 'Diversión',
    soutien: 'Apoyo',
    encouragement: 'Ánimo',
    securite: 'Seguridad',
    apaisement: 'Alivio',
    'croissance-lente': 'Crecimiento lento',
    apprentissage: 'Aprendizaje',
    comprehension: 'Comprensión',
    miroir: 'Espejo',
    'conscience-soi': 'Autoconciencia',
    'conversations-vraies': 'Conversaciones verdaderas',
    detente: 'Relajación',
    legerete: 'Ligereza',
    'presence-sans-enjeu': 'Presencia sin presión',
    rire: 'Risa',
    instantaneite: 'Espontaneidad',
  },
  meetingContexts: {
    'education-formation': 'Educación y formación',
    educatif: 'Educativo',
    formation: 'Formación',
    etude: 'Estudio',
    'event-pro': 'Evento y profesional',
    event: 'Evento',
    'event-pro-item': 'Evento profesional',
    networking: 'Networking',
    'etude-client': 'Estudio de cliente',
    'sport-hobbies': 'Deporte y ocio',
    sportif: 'Deportivo',
    loisir: 'Ocio',
    festival: 'Festival',
    artistique: 'Artístico',
    'voyage-discovery': 'Viaje y descubrimiento',
    voyage: 'Viaje',
    naturel: 'Natural',
    'relations-rencontres': 'Relaciones y encuentros',
    mariage: 'Boda',
    'rencontre-sociale': 'Encuentro social',
    'rencontre-famille': 'Encuentro familiar',
    'rencontre-benevole': 'Encuentro voluntario',
    'famille-proche': 'Familia cercana',
    'event-online': 'Evento en línea',
    eventSpecific: 'Evento específico',
  },
  rrule: {
    custom: 'Personalizada',
  },
  relationshipStatus: {
    growing: 'En crecimiento',
    stable: 'Estable',
    to_reconnect: 'Para reconectar',
    fluctuating: 'Fluctuante',
    declining: 'En declive',
    ended: 'Terminado',
  },
  nearby: {
    headerTitle: 'Cerca',
    pageTitle: 'Contactos cercanos',
    perimeter10: 'Perfiles a menos de 10 km',
    perimeter50: 'Perfiles a menos de 50 km',
    perimeter100: 'Perfiles a menos de 100 km',
    perimeter10Short: 'A menos de 10 km',
    perimeter50Short: 'A menos de 50 km',
    perimeter100Short: 'A menos de 100 km',
    perimeterLabel: 'Perímetros',
    visibilityAll: 'Actualmente eres visible para todos los usuarios.',
    visibilityProfessional: 'Actualmente eres visible para tus contactos profesionales.',
    visibilityPrivate: 'Actualmente eres visible para tus contactos privados.',
    visibilityHidden: 'Actualmente no eres visible para nadie cercano.',
    visibilityAllMobile: 'Visible para todos los usuarios.',
    visibilityProfessionalMobile: 'Visible para tus contactos profesionales.',
    visibilityPrivateMobile: 'Visible para tus contactos privados.',
    visibilityHiddenMobile: 'Visible para nadie.',
    visibilityLoading: 'Cargando tu visibilidad...',
    editVisibility: 'Editar mi visibilidad',
    filterPrivate: 'Privado',
    filterPro: 'Pro',
    emptyNoResults: 'Sin resultados.',
    emptyNoContacts: 'No se encontraron contactos cercanos.',
    groupLabel: 'Perfiles a menos de {distance} km!',
    visibilityOptionAllTitle: 'Pro y Privado',
    visibilityOptionAllDescription:
      'Tu perfil es visible para todos los usuarios (profesionales y privados).',
    visibilityOptionProTitle: 'Pro',
    visibilityOptionProDescription: 'Visible solo para profesionales y empresas.',
    visibilityOptionPrivateTitle: 'Privado',
    visibilityOptionPrivateDescription: 'Visible solo para usuarios privados.',
    visibilityOptionHiddenTitle: 'No ser visible',
    visibilityOptionHiddenDescription: 'Tu perfil no aparece para nadie cercano.',
    modalTitle: 'Editar mi visibilidad',
    modalSubtitle: 'Elige quién puede ver tu perfil en KeepTouch',
    modalHint: 'Marca una o más opciones según tus necesidades.',
    updateButton: 'Actualizar visibilidad',
    scopePrivate: 'Privado',
    scopePro: 'Pro',
  },
  ai: {
    assistant: 'Asistente IA',
    tabSuggest: 'Sugerir',
    tabSummarize: 'Resumir',
    tabAnalyze: 'Analizar',
    generateSuggestions: 'Generar sugerencias',
    use: 'Usar',
    summaryInProgress: 'Resumiendo...',
    analysisInProgress: 'Analizando...',
    sentiment: 'Sentimiento',
    sentimentUndetermined: 'Indeterminado',
    topics: 'Temas tratados',
    dynamics: 'Dinámica',
    keyPoints: 'Puntos clave',
    errorRetry: 'Se produjo un error. Inténtalo de nuevo.',
    instructionsPlaceholder: "Instrucciones (opcional): p. ej. 'tono formal', 'propón una cita'...",
    generatedByAi: 'Mensaje generado por la IA',
  },
  scheduledMessage: {
    create: {
      reasonQuestion: '¿Cuál es el motivo del mensaje?',
      writeManually: 'Escribirlo yo mismo',
      recipientBadge: 'Para',
      reasonBadge: 'Motivo',
      additionalDetailsPlaceholder: 'P. ej. acaba de conseguir un nuevo puesto...',
      messageForContact: 'Mensaje para {name}',
      additionalDetails: 'Detalles adicionales (opcional)',
      scheduledFor: '{date} a las {time}',
    },
    schedule: {
      programButton: 'Programar',
    },
  },
  cardScan: {
    awaitingCamera: 'Esperando la cámara...',
    allowCamera: 'Autorizar la cámara',
    retake: 'Volver a tomar',
    analyze: 'Analizar',
    dragDropPhoto: 'Arrastra y suelta aquí una foto de una tarjeta de visita',
    orClickToSelect: 'o haz clic para seleccionar un archivo',
  },
  qrCodeScan: {
    title: 'Escanear un código QR',
    headerTitle: 'Código QR',
  },
  ghostForm: {
    tagsSection: 'Etiquetas',
    pinsSection: 'Anclados',
    organizeProfile: 'Organizar el perfil',
    hashtagPlaceholder: 'Nombre del #...',
    goalPlaceholder: 'Construir una casa...',
    profileHashtagsName: 'Hashtag del perfil',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
  },
  notes: {
    empty: {
      titleShared: 'Ninguna nota "compartida"',
      titlePersonal: 'Ninguna nota "personal"',
      pressPlusToCreate: 'Pulsa + para crear tu primera nota',
    },
  },
  editCategory: {
    title: 'Editar una categoría',
    deleteConfirm: 'esta categoría',
  },
  editHashtag: {
    deleteConfirm: 'este hashtag',
  },
  editNote: {
    deleteConfirm: 'esta nota',
  },
  ghostProfileExtra: {
    amisEnCommun: 'Amigos en común',
    inContactWith: 'En contacto con {names}',
  },
  formExtra: {
    selectTime: 'Seleccionar una hora',
    yourMessage: 'Tu mensaje...',
    chooseTime: 'Elegir la hora',
    cancel: 'Cancelar',
  },
  filterHeader: {
    clear: 'Borrar',
  },
  messagesPinned: {
    label: 'Anclados',
  },
  translate: {
    toggle: 'Traducir',
    original: 'Texto original',
    lang: {
      fr: 'Francés',
      en: 'Inglés',
      es: 'Español',
    },
  },
  mergeSuggestions: {
    ghostBadge: 'Fantasma',
    realBadge: 'Contacto real',
    reason: {
      FullName: 'Mismo nombre completo',
      LastName: 'Mismo apellido',
      FirstName: 'Mismo nombre',
      Email: 'Mismo email',
      Phone: 'Mismo teléfono',
      LinkedIn: 'Mismo LinkedIn',
      Instagram: 'Mismo Instagram',
      Facebook: 'Mismo Facebook',
      Twitter: 'Mismo Twitter',
    },
  },
  ftSocialImport: {
    title: 'Importar desde una red social',
    chooseNetwork: 'Elige una red social',
    usernameLabel: 'Nombre de usuario',
    linkedinNameLabel: 'Nombre de la persona',
    startImport: 'Iniciar la importación',
    placeholder: {
      linkedin: 'Nombre Apellido (ej: Juan García)',
      facebook: 'URL o nombre de usuario (ej: https://facebook.com/zuck)',
      twitter: 'URL o nombre de usuario (ej: https://x.com/elonmusk)',
      instagram: 'Nombre de usuario (ej: ethpas)',
      generic: 'Nombre de usuario',
    },
    launched: {
      title: 'Importación iniciada',
      message:
        'La importación se ha iniciado. Puedes seguir su progreso desde la lista de contactos.',
      networkMessage: 'La importación de {network} se ha iniciado.',
    },
    error: {
      title: 'Error',
      startFailed: 'No se pudo iniciar la importación',
      validateFailed: 'No se pudo validar la selección',
      genericError: 'Ocurrió un error',
    },
    previousImports: 'Importaciones anteriores',
    newImport: 'Nueva importación',
    inProgress: 'Importación en curso…',
    failed: 'Falló',
    alreadyAdded: 'Ya añadido',
    profilesFound: '{count, plural, one {# perfil encontrado} other {# perfiles encontrados}}',
    networkDescription: {
      linkedin: 'Escribe el nombre de la persona que buscas',
      generic: 'Escribe el nombre de usuario de {network} para importar sus seguidores',
    },
    results: {
      title: 'Resultados — {network}',
      runningHint: 'Esto puede tardar unos minutos',
      failedTitle: 'La importación falló',
      selectAll: 'Seleccionar todo',
      deselectAll: 'Deseleccionar todo',
      validate: 'Validar selección ({count})',
      successTitle: 'Éxito',
      successMessage: '{count, plural, one {# perfil importado} other {# perfiles importados}}',
    },
  },
} as const
